import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { Key } from "@pages/AdminDashboard/ui/Key";
import { UiKitSection } from "@pages/AdminDashboard/ui/UiKitSection";

const [spaceXs, , spaceMd, , spaceXl] = adminTokens.spacing;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
  gap: ${spaceMd}px;
  margin-bottom: ${spaceXl}px;
`;

const Example = styled.div.attrs({ role: "group" })`
  display: flex;
  flex-direction: column;
  gap: ${spaceXs}px;
  border: 1px solid ${adminTokens.color.border};
  border-radius: ${adminTokens.radius.row}px;
  padding: ${spaceMd}px;
`;

const Caption = styled.span`
  color: ${adminTokens.color.inkSoft};
  font-family: ${adminTokens.typeScale.meta.fontFamily};
  font-size: ${adminTokens.typeScale.meta.fontSize};
`;

const Sentence = styled.span`
  color: ${adminTokens.color.inkSoft};
  font-family: ${adminTokens.typeScale.body.fontFamily};
  font-size: ${adminTokens.typeScale.body.fontSize};
`;

// A key alone and a key inside a sentence, each under its own label (KEY-R3, UIKIT-R8).
export const KeySection = () => (
  <UiKitSection title="Key">
    <Grid>
      <Example aria-label="Key alone">
        <Caption>Key alone</Caption>
        <span>
          <Key>/</Key>
        </span>
      </Example>
      <Example aria-label="Key in a sentence">
        <Caption>Key in a sentence</Caption>
        <Sentence>
          Press <Key>/</Key> to search from anywhere.
        </Sentence>
      </Example>
    </Grid>
  </UiKitSection>
);
